import React, { PureComponent } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from "@material-ui/core/DialogContent";
import { dialogActions } from '../../actions/dialog.actions';
import Button from '@material-ui/core/Button';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles'
import { styles } from '../../containers/dockPadStyle'
import { compose } from 'redux'
import DialogActions from '@material-ui/core/DialogActions';
import { connect } from 'react-redux'
import { getProjectId } from '../../selectors/project.selector';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { ThunkDispatch } from 'redux-thunk';
import { entityActions } from '../../actions/entity.actions';
import { phasePlanActions } from '../../actions/phaseplan.actions'
import { ColumnType } from '../PhasePlan/Column';
import { TagType, SelectedTag } from '../../models/ TagType';
import { CollectionsOutlined } from '@material-ui/icons';



export interface Props {
    isDeleteTagDialogOpen: boolean,
    classes: ClassNameMap,
    closeDeleteTagDialog: () => Promise<void>,
    deleteTagValue: (tagId:Record<string, SelectedTag>, type: ColumnType) => Promise<void>,
    clearSelectedPhasePlanTags: () => Promise<void>,
    deleteTagIds: Record<string, SelectedTag>,
    deleteTagType: ColumnType,
}

const DeleteTagDialog: React.FunctionComponent<Props> =
    ({ isDeleteTagDialogOpen, classes, closeDeleteTagDialog, deleteTagValue, deleteTagIds, clearSelectedPhasePlanTags, deleteTagType }) => {
        const closeDialog = () => {
            return async () => {
                closeDeleteTagDialog()
            }
        }

        const deleteTag = () => {
            return async () => {
                if(!deleteTagIds || Object.keys(deleteTagIds).length <= 0) {
                    return 
                } 
                deleteTagValue(deleteTagIds, deleteTagType)
                clearSelectedPhasePlanTags()
                closeDeleteTagDialog()
            }
        }

        return (
          <Dialog
            open={isDeleteTagDialogOpen}
            onBackdropClick={closeDialog()}
          >
            <React.Fragment>
              <DialogContent>
                <div className={classNames(classes.deleteDialog)}>
                    Are you sure you want to delete this tag(s)?
                </div>
              </DialogContent>
              <DialogActions>
                <Button onClick={closeDialog()} color="primary"> Cancel </Button>
                <Button onClick={deleteTag()} color="secondary"> Delete </Button>

              </DialogActions>
            </React.Fragment>
          </Dialog>
        )
    }

const mapStateToProps = (state:any) => ({
    isDeleteTagDialogOpen: !!state.dialogReducer.deleteTagIds && Object.keys(state.dialogReducer.deleteTagIds).length > 0,
    deleteTagIds: state.dialogReducer.deleteTagIds,
    deleteTagType: state.dialogReducer.deleteTagType,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {

    return {
        closeDeleteTagDialog: () => dispatch(dialogActions.closeDeleteTagDialog()),
        deleteTagValue: (tagIds:Record<string, SelectedTag>, type: ColumnType) => dispatch(entityActions.deleteTag(tagIds, type)),
        clearSelectedPhasePlanTags: () => dispatch(phasePlanActions.phasePlanSelectedTagsClearActionAsync())
    }
};
export default compose(
  withStyles(styles, { withTheme: true }),
  connect(mapStateToProps, mapDispatchToProps),

)(DeleteTagDialog);



// WEBPACK FOOTER //
// ./src/components/Dialogs/DeleteTagDialogContainer.tsx